export const UserMobHeaderStyles = {
	container: {
		backgroundColor: 'var(--primary-500)',
		height: '104px',
		display: ' flex',
		alignItems: 'center',
		padding: '44px 20px 16px',
		gap: '16px',
		position: 'relative',

		svg: {
			width: '24px',
			height: '24px',
			path: {
				fill: 'var(--default-white)',
			},

			'@media (max-width: 639.98px)': {
				width: '20px',
				height: '20px',
			},
		},
	},

	title: {
		fontWeight: 700,
		color: 'var(--default-white)',
		fontSize: '20px',
		display: 'flex',
		alignItems: 'center',

		'@media (min-width: 640px)': {
			fontSize: '24px',
			position: 'absolute',
			left: '50%',
			top: '50%',
			transform: 'translate(-50%, -50%)',
			width: 'max-content',
			textAlign: 'center',
		},
	},
};
